/** `status` query param shared by the aggregator and buyer activity lists. */
export type OrgStatus = "active" | "archived";

export const DEFAULT_ORG_STATUS: OrgStatus = "active";

/** Active-state text colour for each status tab (green for active, red for archived). */
export const ORG_STATUS_ACTIVE_CLASSNAMES: Record<OrgStatus, string> = {
  active: "data-[state=active]:text-green-600",
  archived: "data-[state=active]:text-red-600",
};
